import { object, optional, Schema, string } from '../schema';

/**
 * An image file to use in Square catalogs. It can be associated with catalog
 * items, item variations, and categories.
 */
export interface CatalogImage {
  /** The internal name to identify this image in calls to the Square API. */
  name?: string;
  /**
   * The URL of this image, generated by Square after an image is uploaded
   * using the [CreateCatalogImage](#endpoint-Catalog-CreateCatalogImage) endpoint.
   */
  url?: string;
  /**
   * A caption that describes what is shown in the image. Displayed in the
   * Square Online Store. This is a searchable attribute for use in applicable query filters.
   */
  caption?: string;
}

export const catalogImageSchema: Schema<CatalogImage> = object({
  name: ['name', optional(string())],
  url: ['url', optional(string())],
  caption: ['caption', optional(string())],
});
